<template>
	<div>
		<v-dialog v-model="dialog_payment_options" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition">

        	<v-card>
        		<v-toolbar flat>
				    <v-toolbar-side-icon @click="$parent.fn_closeDialog"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

				    <!-- <v-toolbar-title class="white--text">Payment Mode</v-toolbar-title> -->
				    <v-toolbar-title class="white--text two-line-title">
				    	Payment Mode
				    	<div class="toolbar-subtitle">
				    		<div class="subtitle-text dark-opacity-color">Bill Amount: &#8377; {{$root.numberToLocale($parent.roundedAmount)}}</div>
				    	</div>
				    </v-toolbar-title>

				    <v-spacer></v-spacer>
				    <div>
				    	<div style="float: left;margin-right: 12px;margin-top: 6px;color: rgba(0,0,0,0.57);">Split</div>
				    	<v-switch class="hide-margins" hide-details v-model="$parent.Form.splitPayment" @change="fn_splitPayment"></v-switch>
				    </div>

				    <!-- <v-btn round-borders outline @click="fn_checkValidations">Done</v-btn> -->

				</v-toolbar>

        	  	<v-card-text full-height nopadding grey-back>
        	  		<v-form data-vv-scope="fields" full-width class="hasBigFooter">

        	  			<!-- <v-subheader subheader-dense white-background @click="fn_splitPayment">
	                    	<v-spacer></v-spacer>
	                    	<v-icon>{{$parent.Form.splitPayment ? "close" : "call_split"}}</v-icon>&nbsp; {{$parent.Form.splitPayment ? "Cancel Split Payment" : "Split Payment"}}
	                  	</v-subheader> -->

			        	<!-- <div v-for="(item, index) in $parent.Form.paymentGroups" :key="index" full-width v-if="item.accountLedgers && item.accountLedgers.length"> -->
			        	<div v-for="(item, index) in $parent.Form.paymentGroups" :key="index" full-width margin-bottom-ten v-if="fn_isOnCredit(item.accountGroupId)">

			        			<v-subheader white-background v-if="item.accountGroupId != 'creditAccountGroup'">
			        				{{item.accountGroupName != 'Cash - In - Hand' ? item.accountGroupName : 'Cash'}}
			        				<v-spacer></v-spacer>
			        				<v-btn class="mr-0" flat color="primary" icon @click="fn_newLedger(item.accountGroupId, item.accountGroupName, index)">new</v-btn>
			        			</v-subheader>

			        			<v-divider v-if="index!=0 && item.accountLedgers && item.accountLedgers.length"></v-divider>

			        			<v-list nopadding>
			        			<div v-for="(accountItem, accountIndex) in item.accountLedgers" :key="accountIndex">

			        					<v-radio-group col nomargin nopadding hide-details v-model="$parent.Form.paymentLedgerId" v-if="!$parent.Form.splitPayment">

				        					<v-list-tile>
				        						<v-list-tile-action>
				        							<v-radio label="" :value="accountItem.accountLedgerId"></v-radio>
				        						</v-list-tile-action>

				        						<v-list-tile-content @click="$parent.Form.paymentLedgerId = accountItem.accountLedgerId">
				        							<v-list-tile-title>{{accountItem.accountLedgerName}}</v-list-tile-title>
				        						</v-list-tile-content>
										        
										    </v-list-tile>

									    </v-radio-group>

										<template v-if="$parent.Form.splitPayment">
											<v-list-tile v-if="accountItem.accountLedgerId == $parent.creditAccountLedgerId">

												<v-list-tile-content>
													<v-list-tile-title>{{accountItem.accountLedgerName}}</v-list-tile-title>
												</v-list-tile-content>
												
												<v-list-tile-action style="max-width:128px">
													<v-text-field 
														disabled="true"
														prefix="₹"
														style="margin:0"
														hide-details
														right-align
														:value="onCreditAmount"
														type="number"
														label="">
													</v-text-field>
												</v-list-tile-action>

											</v-list-tile>

											<v-list-tile v-else>
								      		
												<v-list-tile-action>
													<!-- <v-checkbox v-model="accountItem.selected" @change="toggleAmount(accountItem, true)"></v-checkbox> -->
													<v-checkbox v-model="accountItem.selected" @change="toggleAmount(accountItem)"></v-checkbox>
												</v-list-tile-action>

												<!-- <v-list-tile-content @click="toggleAmount(accountItem)"> -->
												<v-list-tile-content>
													<v-list-tile-title>{{accountItem.accountLedgerName}}</v-list-tile-title>
												</v-list-tile-content>
												
												<v-list-tile-action v-if="accountItem.selected" style="max-width:128px">
													<v-text-field 
														prefix="₹"
														style="margin:0"
														hide-details
														v-if="$parent.Form.splitPayment"
														right-align
														v-model.number="accountItem.amount"
														type="number"
														label=""
														v-validate="'decimal:2'" 
														:data-vv-name="'amount'+index+accountIndex" 
														data-vv-as="amount"
														:error-messages="errors.collect('amount'+index+accountIndex)">
													</v-text-field>
												</v-list-tile-action>

											</v-list-tile>
										</template>
								      	

							      	<div class="error--text font-small pa-2 full-width" v-if="errors.has('amount'+index+accountIndex)">
	   	          	  					{{ errors.first('amount'+index+accountIndex)}}
	    	          	  			</div>

			        			</div>

			        			</v-list>

						</div>
						
        	  		</v-form>
        	  		
        	  	</v-card-text>

        	  	<div white-background full-width nopadding style="position:fixed;bottom:0;">
					<v-layout row wrap>

						<v-flex xs6 sm6 md6 style="padding:6px 6px 6px 16px" v-if="$parent.Form.splitPayment">
							<div font-medium :class="{'redcolor':totalSum>$parent.roundedAmount}" style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">&#8377; {{$root.numberToLocale(totalSum)}}</div>
							<div style="font-size:11px">Split Total</div>
						</v-flex>
						<v-flex xs6 sm6 md6 :class="{'xs12 sm12 md12 height48':!$parent.Form.splitPayment}">
							<v-btn color="primary" full-height nomargin block no-round-borders noshadow @click="fn_checkValidations">Done</v-btn>
						</v-flex>

					</v-layout>
				</div>

        	  	<!-- <v-divider v-if="$parent.Form.splitPayment"></v-divider>
		        <v-card-actions v-if="$parent.Form.splitPayment">
		        	<v-layout row wrap>
		        		<v-flex xs6 md6 sm6>
		        	  		Bill Amount <br>&#8377; {{$parent.roundedAmount}}
		        		</v-flex>
		        		<v-flex xs6 md6 sm6 right-align :class="{'redcolor':totalSum>$parent.roundedAmount}">
		        	  		Total Payment <br>&#8377; {{totalSum}}
		        		</v-flex>
		        	</v-layout>
		        </v-card-actions> -->
	        </v-card>	
      	</v-dialog>
	</div>
</template>	 	

<script>

export default{
	props:['savePaymentOptions'],
	data(){	
		return{
			dialog_payment_options: false,
			// $parent.Form.paymentLedgerId:null,
			// $parent.Form.splitPayment:null,
			// $parent.Form.paymentGroups:null
		}
	},
	methods:{
		openDialogWeb: function () {	
			this.$validator.reset();
			// this.$parent.Form.splitPayment = this.$parent.Form.$parent.Form.splitPayment;
			// this.$parent.Form.paymentLedgerId = this.$parent.Form.$parent.Form.paymentLedgerId;
			// this.$parent.Form.paymentGroups = JSON.parse(JSON.stringify(this.$parent.Form.$parent.Form.paymentGroups));
			this.dialog_payment_options = true;
		},
		closeDialogWeb: function () {
			this.dialog_payment_options = false;
		},

		fn_isOnCredit: function(accountGroupId){
			if(this.$parent.Form.transactionData.transactionListId == 10003 || this.$parent.Form.transactionData.transactionListId == 20005){
				if(accountGroupId == 'creditAccountGroup' && this.$parent.Form.isCashTransaction){
					return false;
				}
				else{
					return true;
				}
			}
			else{
				return true;
			}
		},

		fn_newLedger: function(accountGroupId, accountGroupName, index){
			// setting up default account group to be selected
			let data = {};
			data.type = 'accountGroup';
			data.id = accountGroupId;
			data.name = accountGroupName;
			localStorage.setItem('newItem', JSON.stringify(data));

			this.$parent.backButtonPress = false;
			this.$parent.Form.paymentGroupIndex = index;
			let self = this;
			this.$parent.fn_saveDraft(this.$parent.Form.partyName, function(){
				self.$router.push({
					path:'/masters/accounts/ledgers/items/new', 
					query:{
						tagId:self.guidWeb(), 
						groupTypeId: 103, 
						ls:1,
						type:'ledger_other',
						dlg:1
					}
				})	
			});

			
		},

		fn_splitPayment: function(){
			// this.$parent.Form.splitPayment = !this.$parent.Form.splitPayment;
			if(this.$parent.Form.splitPayment){
				this.$parent.Form.paymentGroups[0].accountLedgers[0].selected = true;
				this.$parent.Form.paymentGroups[0].accountLedgers[0].amount = this.$parent.roundedAmount;
				// this.toggleAmount(this.$parent.Form.paymentGroups[0].accountLedgers[0], true);
			}
			else{
				// this.$parent.Form.paymentLedgerId = this.$parent.Form.paymentLedgerId ?  this.$parent.Form.paymentLedgerId : this.$parent.creditAccountLedgerId;
				if(this.$parent.Form.transactionData.transactionListId == 20005 && this.$parent.Form.isCashTransaction){
					this.$parent.Form.paymentLedgerId = this.$parent.Form.paymentLedgerId ?  this.$parent.Form.paymentLedgerId : this.$parent.fn_getPaymentCashAccountId();
				}
				else{
					this.$parent.Form.paymentLedgerId = this.$parent.Form.paymentLedgerId ?  this.$parent.Form.paymentLedgerId : this.$parent.creditAccountLedgerId;
				}
			}
		},
		// toggleAmount: function(accountItem, isCheckBox){
		toggleAmount: function(accountItem){
			// if(!isCheckBox){
			// 	accountItem.selected = !accountItem.selected;
			// }

			if(!accountItem.selected){
				accountItem.amount = null;
			}
			else{
				if(this.paymentTotal < this.$parent.roundedAmount){
					accountItem.amount = this.roundUpto2Decimals(this.$parent.roundedAmount - this.paymentTotal);
				}
				// accountItem.amount = this.$parent.Form.paymentGroups[0].accountLedgers[0].amount;
			}


			// this.fn_calculateCreditAmount(accountItem.amount);

		},

		// fn_calculateCreditAmount: function(amount){
		// 	if(this.$parent.Form.paymentGroups[0].accountLedgers[0].amount > amount){
		// 		this.$parent.Form.paymentGroups[0].accountLedgers[0].amount = this.roundUpto2Decimals(this.$parent.Form.paymentGroups[0].accountLedgers[0].amount - amount);
		// 	}
		// 	else{
		// 		if(this.paymentTotal < this.$parent.roundedAmount){
		// 			this.$parent.Form.paymentGroups[0].accountLedgers[0].amount = this.roundUpto2Decimals(this.$parent.roundedAmount - this.paymentTotal);
		// 		}
		// 		else{
		// 			this.$parent.Form.paymentGroups[0].accountLedgers[0].amount = 0;
		// 		}
		// 	}
		// },

		fn_checkValidations: function(){
			// if(this.$parent.Form.splitPayment && this.paymentTotal != this.$parent.roundedAmount){
			if(this.$parent.Form.splitPayment && this.totalSum != this.$parent.roundedAmount){
				// this.$parent.snackbar = true;
				// this.$parent.snackbar_msg = "Total value should be equal to bill amount.";
				this.showToast("Total value should be equal to bill amount");
				return;
			}

			this.$parent.Form.splitPayment = this.$parent.Form.splitPayment;
			this.$parent.Form.paymentGroups = JSON.parse(JSON.stringify(this.$parent.Form.paymentGroups))
			this.savePaymentOptions(this.$parent.Form.paymentLedgerId);	
			this.$parent.fn_closeDialog();
		}
	},
	computed:{
		paymentTotal: function(){
    		let totalPayment = 0;

    		if(this.$parent.Form.paymentGroups){

    			for(let i=0; i<this.$parent.Form.paymentGroups.length; i++){

    				let ledgers = this.$parent.Form.paymentGroups[i].accountLedgers;

					for(let j=0; j<ledgers.length; j++){

						if(ledgers[j].selected && ledgers[j].accountLedgerId != this.$parent.creditAccountLedgerId){
							totalPayment += ledgers[j].amount ? ledgers[j].amount : 0;
						}
					
					}	

				}

    		}
			
			return totalPayment;
		},
		onCreditAmount: function(){
			let creditAmount = 0;
			if(!this.$parent.Form.isCashTransaction && this.paymentTotal < this.$parent.roundedAmount){
				creditAmount = this.roundUpto2Decimals(this.$parent.roundedAmount - this.paymentTotal);
			}

			if(this.$parent.Form.paymentGroups && this.$parent.Form.paymentGroups.length){
				this.$parent.Form.paymentGroups[0].accountLedgers[0].amount = creditAmount;	
			}
			
			if(this.$parent.Form.transactionData.transactionListId == 20005 && this.$parent.Form.isCashTransaction){
				return 0;
			}
			else{
				return creditAmount;
			}
		},
		totalSum: function(){
			return this.roundUpto2Decimals(this.paymentTotal + this.onCreditAmount);
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/dialogs/dialog_payment_options.vue